import dayjs from 'dayjs';
import ru from 'dayjs/locale/ru';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';

dayjs.locale(ru);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);

export type DateUtilType = Date | string | number;

export class DateUtil {
  static now(param?: DateUtilType) {
    return dayjs(param);
  }
}
